"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_virtualized_1 = require("react-virtualized");
var useStyles_1 = __importDefault(require("./useStyles"));
var props_1 = require("../../context/props");
var CellMeasurer = react_virtualized_1.CellMeasurer;
var DataGridCell = function (props) {
    var classes = (0, props_1.usePropsContext)().classes;
    var rowIndex = props.rowIndex, column = props.column, rowData = props.rowData, cellProps = props.cellProps, cache = props.cache, columnIndex = props.columnIndex, parent = props.parent, dataKey = props.dataKey, isDynamicRowHeight = props.isDynamicRowHeight;
    var CellComponent = column.cellComponent, id = column.id;
    var value = rowData[id];
    var internalClasses = (0, useStyles_1.default)();
    return (react_1.default.createElement(CellMeasurer, { cache: cache, columnIndex: columnIndex, parent: parent, key: dataKey, rowIndex: rowIndex }, function (args) {
        var _a;
        var _b;
        return (react_1.default.createElement("div", { ref: args.registerChild, className: ((_b = classes === null || classes === void 0 ? void 0 : classes.cell) === null || _b === void 0 ? void 0 : _b.root) || '' }, CellComponent ? (react_1.default.createElement(CellComponent, { value: value, column: column, rowData: rowData, cellProps: cellProps, rowIndex: rowIndex })) : (react_1.default.createElement("span", { className: (0, classnames_1.default)((_a = {},
                _a[internalClasses.cell] = true,
                _a[internalClasses.dynamicCellHeight] = isDynamicRowHeight,
                _a)) }, value))));
    }));
};
exports.default = DataGridCell;
